import { render, staticRenderFns } from "./_createTaskCta.vue?vue&type=template&id=71ca4379"
import script from "./_createTaskCta.vue?vue&type=script&lang=js"
export * from "./_createTaskCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports